import { z } from 'zod';
/**
 * 商品規格快照 Schema
 * 用於 order_items.variant_snapshot，儲存訂單成立時的商品規格資訊
 * 例如：顏色、尺寸、容量等變體資訊
 */
export const VariantSnapshotSchema = z.object({
    color: z.string().optional().nullable().describe('顏色'),
    size: z.string().optional().nullable().describe('尺寸'),
    capacity: z.string().optional().nullable().describe('容量'),
    material: z.string().optional().nullable().describe('材質'),
    // 允許其他自訂規格欄位
}).passthrough() // 允許額外欄位以支援未來擴展
    .nullable()
    .optional()
    .describe('商品規格快照（JSONB 格式）');
